export { default as NewEducationTable } from './NewEducationTable';
